module.exports = __webpack_public_path__ + "img/banner-medis.c309e31f.jpeg";